import React from 'react';

const Logo = props => (
    <i><b>Vine Supply & Warehouse Management</b></i>
);

export default Logo;